
import TableList from "@components/templates/tablelist";
import { HttpMaterialCostList, HttpExportMaterialCost } from "@/service/billing";
import comExcel from '@components/templates/excelalert';
import { mapGetters } from "vuex";
export default {
    mixins: [TableList],
    components: {
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: { show: true },
            formData: {

            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpMaterialCostList,
        handleOperates(params = "", type, batch) {
            // if (batch === true) {
            //     params = (params || this.checkedData.join(',')) + '';
            //     if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            // }
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpExportMaterialCost, this.formData, { executor: 'request', download: true }).then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    });
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList','getUserManageWarehouseList', 'getBillcusWareList', 'getCusproductList']),
        ToolsData() {
            return [
                {
                    label: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.organization', { defaultValue: "组织" }),
                    tag: 'vSelect',
                    key: 'EQ_orgId',
                    options: this.getBillcusorgList,
                    show: true,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getUserManageWarehouseList,
                    show: true,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.costmanage.bill', { defaultValue: "账单" }),
                    tag: 'vInput',
                    key: 'EQ_billNo',
                },
                {
                    label: this.$t('global.common.line', { defaultValue: "项目" }),
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getCusproductList,
                    show: true,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.accountmanage.material_code', { defaultValue: "包材Code" }),
                    tag: 'vInput',
                    key: 'EQ_materialCode',
                },
                {
                    label: this.$t('fbb.adjustment.bill_no', { defaultValue: "计费单号" }),
                    tag: 'vInput',
                    key: 'EQ_orderNo',
                },
                {
                    label: "Tracking No",
                    tag: 'vInput',
                    key: 'EQ_trackingNo',
                },
                // {
                //     label: "状态",
                //     key: 'EQ_billId',
                //     more: true,
                //     tag: 'vSelect',
                //     options: this.getBillingDetailStatus,
                //     props: {
                //         filterable: true,
                //     },
                // },
                {
                    label: this.$t('global.common.createdtime', { defaultValue: "创建日期" }),
                    tag: 'vDatepicker',
                    style: "width:362px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                }
            ]
        },
        columns() {
            return [{
                title: this.$t('global.common.organization', { defaultValue: '组织' }) + '/' + this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                render: (h, { row }) => {
                    let orgId = row.orgId
                    const { label } = this.getBillcusorgList.find(function (item) {
                        return item.value == orgId
                    }) || {};
                    return <div>
                        <div>{label || '--'}</div>
                        <div>{row.warehouseCode || '--'}</div>
                    </div>
                }
            },
            {
                title: this.$t('fbb.costmanage.bill', { defaultValue: '账单' }),
                key: 'billNo',
                render: (h, { row }) => {
                    return <div>
                        {this.$t('fbb.costmanage.bill', { defaultValue: '账单' })} : {row.billNo}
                        <div>{this.$t('global.common.status', { defaultValue: '状态' })}:{row.billId == 0 ? this.$t('fbb.costmanage.not_out_bill', { defaultValue: '未出账' }) : this.$t('fbb.costmanage.has_out_bill', { defaultValue: '已出账' })}</div>
                    </div>
                }
            },
            {
                title: this.$t('fbb.costmanage.material', { defaultValue: '包材' }),
                key: 'materialName',
            },
            {
                title: this.$t('fbb.accountmanage.feilv', { defaultValue: '费率' }) + '*' + this.$t('fbb.accountmanage.amount', { defaultValue: '数量' }),
                render: (h, { row }) => {
                    return <div>
                        {row.baseRate} * {row.qty}
                    </div>
                }
            },
            {
                title: this.$t('fbb.billmanage.total_cost', { defaultValue: '总费用' }),
                key: 'cost',
                render(h, { row }) {
                    return `${row.cost} ${row.currency || 'USD'}`
                }
            },
            {
                title: `${this.$t('fbb.adjustment.bill_no', { defaultValue: "计费单号" })}/${this.$t('fbb.costmanage.distinguish_number', { defaultValue: "识别号" })}/Tracking No`,
                width: 180,
                render: (h, { row }) => {
                    return <div>
                        {row.orderNo || '--'}
                        <div>{row.sourceNo || '--'}</div>
                        <div>{row.trackingNo || '--'}</div>
                    </div>
                }
            },
            {
                title: `${this.$t('global.common.line', { defaultValue: "项目" })}/${this.$t('global.common.notes', { defaultValue: '备注' })}`,
                key: 'lineId',
                render: (h, { row }) => {
                    let lineId = row.lineId
                    const { label } = this.getCusproductList.find(function (item) {
                        return item.value == lineId
                    }) || {};
                    return <div>
                        {label || '--'}
                        <div>{row.remark || '--'}</div>
                    </div>
                }
            },
            {
                title: this.$t('global.common.createdtime', { defaultValue: '创建日期' }),
                key: 'createdAt',
                sortable: true
            }
            ];
        },

    },

};
